import apiSlice from "./ApiSlice";
import { v4 as uuid } from "uuid";

const deviceId = localStorage.getItem("deviceId") || uuid();

export const studentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    getStudents: builder.query({
      providesTags: ["student"],
      query: (body: any) => {
        return {
          url: "/admission",
          method: "POST",
          body,
        };
      },
    }),
    // GET ALL
    getAllStudents: builder.query({
      query: () => {
        return {
          url: '/admission',
          method: 'GET',
        };
      },
    }),
    // ADD
    addStudent: builder.mutation({
      invalidatesTags: ["student"],
      query: (body) => {
        return {
          url: "/admission/add",
          method: "POST",
          body,
        };
      },
    }),
    // EDIT
    editStudent: builder.mutation({
      invalidatesTags: ["student"],
      query: ({ body, id }) => {
        return {
          url: `/admission/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    //Single View
    viewStudentById: builder.query({
      providesTags: ["student"],
      query: (id: any) => {
        return {
          url: `/admission/${id}`,
          method: "GET",
        };
      },
    }),
    //GET STUDENT BY MOBILE NUMBER
    getStudentDetailByNumber: builder.query({
     providesTags: ["student"],
      query: (number: any) => {
        return {
          url: `/inquiry/get-student-detail/${number}`,
          method: "GET", };
        },
      }),

    // assign-batches listing
    assignBatchesStudentById: builder.query({
      providesTags: ["student"],
      query: (id: any) => {
        return {
          url: `/admission/all-assigned-batches/${id}`,
          method: "GET",
        };
      },
    }),
     // GET
     getAllStudentAttendanceCount: builder.query({
      providesTags: ["student" , "batches"],
      query: (body: any) => {
        return {
          url: "/attendance/get-attendance-count",
          method: "POST",
          body,
        };
      },
    }),
      // GET
      getAllStudentAttendanceCalendar: builder.query({
        providesTags: ["student"],
        query: (body: any) => {
          return {
            url: "/attendance/get-student-callender",
            method: "POST",
            body,
          };
        },
      }),


         //ASSIGNMENTS 
           // GET
    getAllAssigmentsStudent: builder.query({
      providesTags: ["student"],
      query: (body: any) => {
        return {
          url: "/assignment/student-assignment",
          method: "POST",
          body,
        };
      },
    }),
    //Add Comment
    addCommentOnAssigment : builder.mutation({
      invalidatesTags: ["student"],
       query: ({body ,id}:any) => {
        return {
          url: `/assignment/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    //Update Student Password
     updateStudentPassword: builder.mutation({
      invalidatesTags: ["student"],
      query: (body) => {
        return {
          url: `/student/admin/change-password`,
          method: "PUT",
          headers: {
            "device-id": deviceId,
          },
          body,
        };
      },
    }),

    //Get all Assignments 
    getNotCompletedAssignmentsStudents: builder.query({
      providesTags: ["student"],
      query: (body: any) => {
        return {
          url: "/admission/incompleted-assignment-count",
          method: "POST",
          body,
        };
      },
    }),

    //Change Student Status 
     changeStudentStatus : builder.mutation({
      invalidatesTags: ["student"],
       query: (id) => {
        return {
          url: `/admission/status-change/${id}`,
          method: "PUT",
        };
      },
    }),

     //Change Student Batch Status 
     changeStudentBatchStatus : builder.mutation({
      invalidatesTags: ["student"],
       query: ({body,id}:any) => {
        return {
          url: `/student/batch/${id}`,
          method: "PUT",
          body
        };
      },
    }),

  
  }),
});

export const {
  useGetStudentsQuery,
  useGetAllStudentsQuery,
  useAddStudentMutation,
  useEditStudentMutation,
  useGetStudentDetailByNumberQuery,
  useViewStudentByIdQuery,
  useAssignBatchesStudentByIdQuery,
  useGetAllStudentAttendanceCountQuery ,
  useGetAllStudentAttendanceCalendarQuery,
  useGetAllAssigmentsStudentQuery,
  useAddCommentOnAssigmentMutation,
  useUpdateStudentPasswordMutation,
  useGetNotCompletedAssignmentsStudentsQuery ,
  useChangeStudentStatusMutation ,
  useChangeStudentBatchStatusMutation
} = studentApi;
